export function ShouldShowQuickJournalDemoStats(): boolean {
    if (typeof window === "undefined") {
        return false;
    }

    if (new URLSearchParams(window.location.search).has("quickJournalDemo")) {
        return true;
    }

    if (window.location.hostname !== "localhost") {
        return false;
    }

    return true;
}

export function IsIosDevice(): boolean {
    if (typeof navigator === "undefined") {
        return false;
    }

    const platform = navigator.platform || "";
    const userAgent = navigator.userAgent || "";

    return (
        /iPad|iPhone|iPod/.test(userAgent) ||
        (platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
}

export function IsVisualViewportFullyOpen(): boolean {
    if (!window.visualViewport) {
        return true;
    }

    const visualViewportBottom =
        window.visualViewport.offsetTop + window.visualViewport.height;

    return visualViewportBottom >= window.innerHeight - 2;
}

export function GetVisualViewportBottomInset(): number {
    if (!window.visualViewport) {
        return 0;
    }

    const visualViewportBottom =
        window.visualViewport.offsetTop + window.visualViewport.height;

    return Math.max(0, window.innerHeight - visualViewportBottom);
}

export function GetFocusedIosJournalOffset(keyboardInset: number): number {
    if (keyboardInset <= 0) {
        return 0;
    }

    return -Math.min(112, Math.max(72, keyboardInset * 0.18));
}